import { compose } from 'recompose';

import MetaCreate from './MetaCreate';

const enhance = compose();

export default enhance(MetaCreate);
